import LibraryContent from 'components/LibraryContent';

const Library = () => {
  return (
    <div>
      <LibraryContent />
    </div>
  );
};

export default Library;
